import useEnqueueSnackbar from 'hooks/useEnqueueSnackbar';
import useTenantLegalDocuments from 'hooks/useTenantLegalDocuments/useTenantLegalDocuments';
import React, { useState } from 'react';
import RulesPage from 'ui/templates/RulesPage/RulesPage';

export interface Props {}

const AcceptLegalDocumentsPage: React.FC<React.PropsWithChildren<Props>> = () => {
  const enqueueSnackbar = useEnqueueSnackbar();
  const handleFetchError = (errorMessage: string) => enqueueSnackbar(errorMessage, { snackbartype: 'error' });
  const { tenantLegalDocuments, acceptedLegalDocuments, acceptedLegalDocumentsLoading } = useTenantLegalDocuments({
    handleFetchError
  });

  const [isSLACheckBoxSelected, setIsSLACheckBoxSelected] = useState(false);
  const [isSLARulesAccepted, setIsSLARulesAccepted] = useState(false);
  const [isPDACheckBoxSelected, setIsPDACheckBoxSelected] = useState(false);

  const handleSLACheckBoxClick = () => {
    setIsSLACheckBoxSelected(!isSLACheckBoxSelected);
  };

  const handleSLAButtonOnClick = () => {
    if (isSLACheckBoxSelected) setIsSLARulesAccepted(true);
  };

  const handleDPACheckBoxClick = () => {
    setIsPDACheckBoxSelected(!isPDACheckBoxSelected);
  };

  const handleDPAButtonOnClick = () => {
    if (!acceptedLegalDocumentsLoading && tenantLegalDocuments) {
      acceptedLegalDocuments({
        dpa: tenantLegalDocuments.dpa.id,
        sla: tenantLegalDocuments.sla.id
      });
    }
  };

  const rulesPageToShow = !isSLARulesAccepted ? (
    <RulesPage
      title="ATLAS Access – Software License Agreement"
      rulesContent={tenantLegalDocuments?.sla.currentText ?? ''}
      rulesName="Software License Agreement (SLA)"
      isCheckBoxChecked={isSLACheckBoxSelected}
      handleCheckBoxOnClick={handleSLACheckBoxClick}
      handleButtonOnClick={handleSLAButtonOnClick}
      isLoading={!tenantLegalDocuments}
    />
  ) : (
    <RulesPage
      title="ATLAS Access – Data Processing Agreement"
      rulesContent={tenantLegalDocuments?.dpa.currentText ?? ''}
      rulesName="Data Processing Agreement (DPA)"
      isCheckBoxChecked={isPDACheckBoxSelected}
      handleCheckBoxOnClick={handleDPACheckBoxClick}
      handleButtonOnClick={handleDPAButtonOnClick}
      isLoading={!tenantLegalDocuments}
    />
  );

  return rulesPageToShow;
};

export default AcceptLegalDocumentsPage;
